module.exports = __webpack_public_path__ + "static/logo-91b65bf09beebe2a08aa00c217986261.svg";